/**
 * Copyright (c) 2018-2019 Aleksey Melnikov, True Directive Company.
 * @link https://truedirective.com/
 * @license MIT
*/
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';

import { Selection } from '@true-directive/base';
import { CellPosition } from '@true-directive/base';

export class GridSelection extends Selection {
  // ÐÐ·Ð¼ÐµÐ½ÐµÐ½ ÑÐ¾ÐºÑÑ
  protected _onFocusChanged: Subject<CellPosition> = new Subject();
  public readonly onFocusChanged: Observable<CellPosition> = this._onFocusChanged.asObservable();

  // ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¾ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð¸Ðµ. ÐÑÐ³ÑÐ¼ÐµÐ½Ñ - Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÑÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾ range
  protected _onSelectionChanged: Subject<CellPosition> = new Subject();
  public readonly onSelectionChanged: Observable<CellPosition> = this._onSelectionChanged.asObservable();

  protected selectionChangedEvent(cp: CellPosition) {
    this._onSelectionChanged.next(cp);
  }

  protected focusChangedEvent(cp: CellPosition) {
    this._onFocusChanged.next(cp);
  }

  constructor() {
    super();
  }
}
